<div flexLayout="column" flexLayoutAlign="start stretch">
  <ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{
      specialties: specialties$ | async
    }"
  >
  </ng-container>
</div>

<ng-template #template let-specialties="specialties">
  <form [formGroup]="form">
    <div mat-dialog-title>
      <h1>Add Specialty</h1>
    </div>
    <mat-dialog-content flexLayout="row">
      <mat-form-field flex>
        <mat-label>Specialty</mat-label>
        <mat-select required formControlName="specialtyTagId" multiple="true">
          <mat-option
            *ngFor="let specialty of specialties; trackBy: trackById"
            [value]="specialty.tagId"
          >
            {{ specialty.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions flexLayoutAlign="end center">
      <button type="button" mat-flat-button (click)="onCancel()">Cancel</button>
      <button
        type="button"
        mat-raised-button
        (click)="onSave()"
        color="primary"
        [disabled]="form.invalid"
      >
        Commit
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
